"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalizedAnalyticsEndpoint = exports.getCurrentUrl = exports.getCurrentReferrer = exports.getTopLevelDomain = exports.getSubdomain = exports.getLocalDomain = exports.isLocalDomain = exports.getRootDomain = void 0;

var _misc = require("./misc");

var _logger = _interopRequireDefault(require("./logger"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var getRootDomain = function getRootDomain(url) {
  var parsed = new _urlParse["default"](url);
  var hostnamePortions = parsed.hostname.split('.');
  var cheggIdx = hostnamePortions.findIndex(function (portion) {
    return portion.toLowerCase() === 'chegg';
  });

  if (cheggIdx === -1) {
    cheggIdx = -2;
  }

  return hostnamePortions.slice(cheggIdx).join('.');
};

exports.getRootDomain = getRootDomain;

var isLocalDomain = function isLocalDomain(url) {
  var parsed = new _urlParse["default"](url);
  var hostnamePortions = parsed.hostname.split('.');
  return !isNaN(Number(hostnamePortions[0]));
};

exports.isLocalDomain = isLocalDomain;

var getLocalDomain = function getLocalDomain(url) {
  var parsed = new _urlParse["default"](url);
  var hostnamePortions = parsed.hostname.split('.');
  return hostnamePortions[0];
};

exports.getLocalDomain = getLocalDomain;

var getSubdomain = function getSubdomain(url) {
  var parsed = new _urlParse["default"](url);
  var hostnamePortions = parsed.hostname.split('.');

  if (hostnamePortions.length >= 3) {
    return hostnamePortions[0];
  } else {
    return;
  }
};

exports.getSubdomain = getSubdomain;

var getTopLevelDomain = function getTopLevelDomain(url) {
  var parsed = new _urlParse["default"](url);
  var hostnamePortions = parsed.hostname.split('.');
  var ignoredTLDs = ['mx'];
  var topLevelDomain;

  do {
    topLevelDomain = hostnamePortions.pop();
  } while (ignoredTLDs.includes(topLevelDomain));

  if (isNaN(Number(topLevelDomain))) {
    return parsed.protocol === 'chrome-extension:' ? 'com' : topLevelDomain;
  } else {
    // If last segment of hostname is a number, we are hitting an ip directly (likely in test env)
    // In this case, use fallback
    return 'tst';
  }
};

exports.getTopLevelDomain = getTopLevelDomain;

var getCurrentReferrer = function getCurrentReferrer(exitingReferrer) {
  var currentReferrer;

  if (!(0, _misc.noWindow)()) {
    // If there is a window object, check if exitingReferrer and current window referrer is same,
    // if its same, then set it to chegg.com,
    // if its not same, then set it to current window referrer
    if (exitingReferrer === window.document.referrer) {
      currentReferrer = 'www.chegg.com';
    } else {
      currentReferrer = window.document.referrer;
    }
  } else if (exitingReferrer) {
    // If there is no window object, we're on the server side, and the
    // initiating app should have fed in the referrer. Use this.
    currentReferrer = exitingReferrer;
  } else {
    // Looks like the initiating app never gave us a url.
    // Alert and return an empty string.
    currentReferrer = '';
  }

  return currentReferrer;
};

exports.getCurrentReferrer = getCurrentReferrer;

var getCurrentUrl = function getCurrentUrl(urlFromState) {
  var currentUrl;

  if (urlFromState) {
    // if initiating app have fed in the url. Use this as current url.
    currentUrl = urlFromState;
  } else if (!(0, _misc.noWindow)()) {
    // If there is a window object, always go to it for the latest URL
    currentUrl = window.location.href;
  } else {
    // Looks like the initiating app never gave us a url.
    // Alert and return an empty string.
    _logger["default"].error(new Error('No url passed into state'));

    currentUrl = '';
  }

  return currentUrl;
};
/**
 * Takes the currently configured analytics endpoint and updates the domain to `*.com.mx` if
 * the current location is at a `*.com.mx` website.
 * @param value the current analytics endpoint
 * @param location current window location
 * @returns a localized analytics endpoint
 */


exports.getCurrentUrl = getCurrentUrl;

var getLocalizedAnalyticsEndpoint = function getLocalizedAnalyticsEndpoint(value, location) {
  var result = value;

  if (location && value) {
    var currentLocationHost = location.host;
    var endpointUrl = new URL(value);
    var internationalTldRx = /\.com\.mx$/;

    if (internationalTldRx.test(currentLocationHost) && /analytics.*(chegg|cheggnet)\.com$/.test(endpointUrl.host)) {
      endpointUrl.host = endpointUrl.host.replace(/\.com$/, '.com.mx');
      result = endpointUrl.href;
    }
  }

  return result;
};

exports.getLocalizedAnalyticsEndpoint = getLocalizedAnalyticsEndpoint;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/rio-sdk-web/dist/cjs/utils/urls.js
// module id = 474
// module chunks = 11